import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { AuthStore } from '../stores';
import { DEFAULT_AUTH_SUCCESS_ROUTE } from '../utils';

export const guestGuard: CanActivateFn = (): boolean | UrlTree => {
  const store = inject(AuthStore);
  const router = inject(Router);

  store.hydrateSession();

  return store.isAuthenticated() ? router.parseUrl(DEFAULT_AUTH_SUCCESS_ROUTE) : true;
};
